import { Fragment, useState } from "react";
import { LocalizedDateTime } from "../../components/LocalizedDate";
import { SKTProgressBar } from "../../components/SKTProgressBar";
import { API_ENDPOINTS } from "../../config";
import { useAPI } from "../../hooks/APIHook";
import { Address } from "../../views/common/Address";
import { Table, TableBody, TableHead, TableRow } from "../components/Table";
import { Order } from "./Order";

const Contents = ({ contents }) => {
  return <Fragment>{contents.contents}</Fragment>;
};

const OrderList = ({ orders, setSelected }) => {
  if (orders.status === "pending")
    return <SKTProgressBar label="Tietoja haetaan" />;

  return (
    <Table>
      <TableHead>
        <TableRow>
          <th scope="col">#</th>
          <th scope="col">Rahti#</th>
          <th scope="col">PVM</th>
          <th scope="col"></th>
          <th scope="col">Mistä</th>
          <th scope="col">Minne</th>
          <th scope="col">Sisältö</th>
          <th scope="col">Hinta</th>
        </TableRow>
      </TableHead>
      <TableBody>
        {orders.orders.map((o) => (
          <TableRow onClick={() => setSelected(o.number)}>
            <th scope="row">{o.number}</th>
            <td>{o.waybills.id}</td>
            <td>
              <LocalizedDateTime datetime={o.created} />
            </td>
            <td>{o.from_private ? "Yksityinen" : "Yritys"}</td>
            <td>
              <Address address={o.src} />
            </td>
            <td>
              <Address address={o.dst} />
            </td>
            <td>
              <Contents contents={o.contents} />
            </td>
            <td>{o.price.total.toFixed(2)}&nbsp;€</td>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export const OrderListView = () => {
  const [search, setSearch] = useState({});

  const searchOnChange = (event) => {
    setSearch({ q: event.target.value });
  };

  const [selected, setSelected] = useState(null);
  const [orders] = useAPI(API_ENDPOINTS.admin.orders, search);

  if (selected) {
    const order = orders.orders.find((c) => c.number === selected);
    if (order)
      return <Order order={order} doReturn={() => setSelected(null)} />;
  }
  return (
    <Fragment>
      <input
        class="form-control me-2"
        type="search"
        placeholder="Search"
        aria-label="Search"
        onChange={searchOnChange}
        value={search?.q}
      />
      <OrderList orders={orders} setSelected={setSelected} />
    </Fragment>
  );
};
